import { render, staticRenderFns } from "./SessionFilterBar.vue?vue&type=template&id=5c121248"
import script from "./SessionFilterBar.vue?vue&type=script&lang=ts"
export * from "./SessionFilterBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports